module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmuskel4-4b3af38124db20a823c96823807d29bb.jpg";